import { NonValueSymbol } from '../model/SymbolModel'

/**
 * Constant defining data of a blank symbol
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

// data for a symbol that is blank
export const BLANK_SYMBOL: NonValueSymbol = { id: 14 }
